import { FunctionComponent } from 'react';
import LightbulbOutlined from '@mui/icons-material/LightbulbOutlined';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';
import SolarPowerOutlined from '@mui/icons-material/SolarPowerOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import '../../../css/PublicAboutUsPage.css';

const Component03: FunctionComponent = () => {
  return (
    <div className='public-about-us-page-component-three-container vdr-about-panel'>
      <div className='vdr-section-head vdr-about-section-head'>
        <h2 className='public-about-us-page-subtitle-text'>Nuestros Valores</h2>
        <small>Principios</small>
      </div>
      <p className='public-about-us-page-text vdr-about-lead'>
        En VisiónDERRED, nos guiamos por valores que reflejan nuestro compromiso con la excelencia
        y la innovación. Entre los valores que impulsan nuestra empresa se encuentran:
      </p>
      <ul className='public-what-we-do-page-list vdr-about-values'>
        <li>
          <span className='vdr-icon-tile' aria-hidden='true'>
            <LightbulbOutlined />
          </span>
          <b>Innovación:</b> Nos dedicamos a ofrecer soluciones creativas y vanguardistas que se
          adaptan a las necesidades del mercado.
        </li>
        <li>
          <span className='vdr-icon-tile' aria-hidden='true'>
            <HandshakeOutlined />
          </span>
          <b>Compromiso:</b> Nos comprometemos a ayudar a nuestros clientes a alcanzar sus
          objetivos, brindándoles soporte y soluciones de alto impacto.
        </li>
        <li>
          <span className='vdr-icon-tile' aria-hidden='true'>
            <SolarPowerOutlined />
          </span>
          <b>Sostenibilidad:</b> Creemos en un futuro sostenible, por lo que desarrollamos
          tecnologías que contribuyen a impulsar la integración de recursos energéticos distribuidos
          como sistemas fotovoltaicos residenciales o vehículos eléctricos, facilitando la
          integración de generación renovable y el cumplimiento de objetivos de reducción de
          emisiones.
        </li>
        <li>
          <span className='vdr-icon-tile' aria-hidden='true'>
            <GroupsOutlined />
          </span>
          <b>Colaboración:</b> Fomentamos la cooperación tanto dentro de nuestro equipo como con
          empresas e instituciones, buscando siempre proporcionar valor a nuestros usuarios.
        </li>
      </ul>
    </div>
  );
};

export default Component03;
